export const handleApiError = async (response, defaultMessage) => {
  try {
    const errorData = await response.json();
    
    if (errorData.errors && errorData.errors.length > 0) {
      // Return the first error message from the backend
      return errorData.errors[0].message || defaultMessage;
    }
    
    return errorData.message || defaultMessage;
  } catch (parseError) {
    console.error('Error parsing error response:', parseError);
    return defaultMessage;
  }
};